module.exports = __webpack_public_path__ + "img/310-71ed84.png";